import { RouteConfig } from "vue-router";

const tipoEgresos: RouteConfig = {
  path: "/tipoEgresos",
  name: "tipoEgresos",
  component: () => import(/* webpackChunkName: "tipo-egresos" */ "@/views/TipoEgresos.vue"),
};

export default tipoEgresos;
